/**
 * VideoMail recording rooms and the recorder that joins them.
 *
 * A VideoMail room holds one person and a Jibri recorder. The recorder
 * signs in on its own XMPP domain; lib-jitsi-meet hides exactly one domain
 * from the roster (`config.hiddenDomain`), and in ordinary calls that slot
 * belongs to the quality-observer domain. For a VideoMail room the observer
 * never joins, so the slot is given to the recorder instead: the person
 * recording sees only themselves, not a "Recorder" participant.
 */
export const VIDEOMAIL_MESSAGE_ROOM_PREFIX = 'voicemail-';
export const VIDEOMAIL_GREETING_ROOM_PREFIX = 'videomail-greeting-';
/** Where the recorder authenticates; must match XMPP_RECORDER_DOMAIN in the deployment. */
export const VIDEOMAIL_RECORDER_DOMAIN = 'recorder.meet.jitsi';
export function isVideoMailRoom(room) {
    const name = String(room || '').toLowerCase();
    return name.startsWith(VIDEOMAIL_MESSAGE_ROOM_PREFIX) || name.startsWith(VIDEOMAIL_GREETING_ROOM_PREFIX);
}
/**
 * Returns the config to use for `room`: unchanged for ordinary rooms, a copy
 * with the recorder domain hidden for VideoMail rooms.
 */
export function applyVideoMailRoomConfig(config, room) {
    if (!config || !isVideoMailRoom(room)) {
        return config;
    }
    // IConfig does not declare hiddenDomain (it is whitelisted, not typed).
    return { ...config, hiddenDomain: VIDEOMAIL_RECORDER_DOMAIN };
}
